import { Spinner } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import styles from './FullPageLoader.module.css'

export const FullPageLoader = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.page} role='status'>
      <Spinner aria-label={t('loader.loading')} />
    </div>
  )
}
